import { SCOPE } from './types';
import { sagas as birdChartSagas } from './birdChart';
import { sagas as sharingSagas } from './sharing';
import commonSagas from './sagas';
export { SCOPE };
export { default as selector } from './selectors';

export const sagas = [...birdChartSagas, ...sharingSagas, ...commonSagas];

export { default as reducer } from './reducer';
